import { render, staticRenderFns } from "./ApplicationsList.vue?vue&type=template&id=2d5fc55a&scoped=true&"
import script from "./ApplicationsList.vue?vue&type=script&lang=js&"
export * from "./ApplicationsList.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/project-applications.scss?vue&type=style&index=0&id=2d5fc55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5fc55a",
  null
  
)

export default component.exports